import React from 'react';

export const SecondPlateSeparatorIcon = () => (
  <svg
    data-name="Group 409"
    height="5.193"
    id="Group_409"
    viewBox="0 0 4.358 5.193"
    width="4.358"
    xmlns="http://www.w3.org/2000/svg">
    <g id="insignia-escudo-con-contorno" transform="translate(0 0)">
      <g data-name="Group 408" id="Group_408">
        <path
          d="M67.383,44.721c-.6,1.339,1.679,1.361,2,2.206.042.109.034.109.076,0,.324-.846,2.6-.867,2-2.206a1.846,1.846,0,0,1,.113-2.082.094.094,0,0,0,0-.122l-.54-.621a.107.107,0,0,0-.126-.023A1.756,1.756,0,0,1,69.5,41.83a.212.212,0,0,0-.148,0,1.755,1.755,0,0,1-1.418.044.107.107,0,0,0-.126.023l-.54.621a.094.094,0,0,0,0,.122A1.845,1.845,0,0,1,67.383,44.721Z"
          data-name="Path 191"
          id="Path_191"
          transform="translate(-67.246 -41.816)"
        />
      </g>
    </g>
    <path
      d="M135.993,140.866l-.42.793-.884.154.625.644-.127.889.806-.4.806.4-.127-.889.625-.644-.884-.154Z"
      data-name="Path 192"
      fill="#fff"
      id="Path_192"
      transform="translate(-133.838 -139.752)"
    />
  </svg>
);
